import { makeObservable, observable, flow, computed, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { Add } from "@/components/icons/IconMap";

import BrowseSubscribersSchema from "@/areas/subscriptions/schemas/BrowseSubscribersSchema";

export default class BrowseSubscribersStore {
  visible = false;
  loading = false;
  pagination = null;
  subscribers = [];

  constructor(parentStore, apiPrefix) {
    makeObservable(this, {
      visible: observable,
      loading: observable,
      pagination: observable,
      subscribers: observable,
      actions: computed,
      load: flow,
      show: flow,
      hide: action,
      toggle: flow,
    });

    this.parentStore = parentStore;
    this.apiPrefix = apiPrefix;
  }

  *show() {
    this.visible = true;
    return yield this.load({ search: "", page: 1 });
  }

  hide() {
    this.visible = false;
  }

  *toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
    if (this.visible) {
      return yield this.load({ search: "", page: 1 });
    }
  }

  get actions() {
    const list = [];

    list.push({
      id: "subscription:add-subscriber",
      label: "New Subscriber",
      onClick: () => this.parentStore.addSubscriberStore.show(),
      icon: Add,
      location: "primary",
      processing: this.parentStore.addSubscriberStore.processing,
      disabled: this.parentStore.addSubscriberStore.processing,
    });

    return list;
  }

  consume(subscriber) {
    const index = this.subscribers.findIndex((e) => e.id === subscriber.id);
    if (index !== -1) {
      this.subscribers.splice(index, 1, subscriber);
      this.subscribers = [...this.subscribers];
    }
  }

  *load(query, options) {
    const parseResult = BrowseSubscribersSchema.safeParse(query);
    if (!parseResult.success) {
      return parseResult;
    }
    try {
      this.loading = true;
      const response = yield api.get(`${this.apiPrefix}/subscribers`, {
        params: query,
      });
      this.subscribers = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while loading subscribers", {
        description: e.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
